// Artifact `data` arrives either pre-parsed (streaming path) or as a JSON
// string (reload path). Returns the object, or null when absent/unparseable.
export const parseArtifactData = data => {
    if (!data) return null;
    if (typeof data === 'object') return data;
    try {
        return JSON.parse(data);
    } catch {
        return null;
    }
};
